export function aboutUsAnimation() {
  const aboutUsShortCode = document.querySelector(
    ".about-us-text-shortcode-container"
  ) as HTMLElement;

  if (!aboutUsAnimation) return;

  // text animation
  const triggerElement = document.querySelector(
    ".text-effect-trigger"
  ) as HTMLElement;

  // set initial transform css to letters
  const lettersOdd = document.querySelectorAll(".letter-odd") as NodeList;
  lettersOdd.forEach((letterOdd: HTMLElement) => {
    letterOdd.style.transform = `translate(0%, -60%) translate3d(0px, 0px, -40px) rotateY(180deg) scale(0, 0)`;
  });
  const lettersEven = document.querySelectorAll(".letter-even") as NodeList;
  lettersEven.forEach((letterEven: HTMLElement) => {
    letterEven.style.transform = `translate(0%, 60%) translate3d(0px, 0px, -40px) rotateY(-180deg) scale(0, 0)`;
  });

  const letter1 = document.querySelector(".letter1") as HTMLElement;
  const letter2 = document.querySelector(".letter2") as HTMLElement;
  const letter3 = document.querySelector(".letter3") as HTMLElement;
  const letter4 = document.querySelector(".letter4") as HTMLElement;
  const letter5 = document.querySelector(".letter5") as HTMLElement;
  const letter6 = document.querySelector(".letter6") as HTMLElement;
  const letter7 = document.querySelector(".letter7") as HTMLElement;
  const letter8 = document.querySelector(".letter8") as HTMLElement;
  const letter9 = document.querySelector(".letter9") as HTMLElement;
  const letter10 = document.querySelector(".letter10") as HTMLElement;
  const letter11 = document.querySelector(".letter11") as HTMLElement;
  const letter12 = document.querySelector(".letter12") as HTMLElement;
  const letter13 = document.querySelector(".letter13") as HTMLElement;
  const letter14 = document.querySelector(".letter14") as HTMLElement;
  const letter15 = document.querySelector(".letter15") as HTMLElement;
  const letter16 = document.querySelector(".letter16") as HTMLElement;
  const letter17 = document.querySelector(".letter17") as HTMLElement;
  const letter18 = document.querySelector(".letter18") as HTMLElement;
  const letter19 = document.querySelector(".letter19") as HTMLElement;
  const letter20 = document.querySelector(".letter20") as HTMLElement;
  const letter21 = document.querySelector(".letter21") as HTMLElement;
  const letter22 = document.querySelector(".letter22") as HTMLElement;
  const letter23 = document.querySelector(".letter23") as HTMLElement;
  const letter24 = document.querySelector(".letter24") as HTMLElement;
  const letter25 = document.querySelector(".letter25") as HTMLElement;
  const letter26 = document.querySelector(".letter26") as HTMLElement;
  const letter27 = document.querySelector(".letter27") as HTMLElement;
  const letter28 = document.querySelector(".letter28") as HTMLElement;
  const aboutUsTextTitle = document.querySelector(
    ".about-us-text-title"
  ) as HTMLElement;
  aboutUsTextTitle.style.opacity = "0";

  function textEffect1(percentage: number, element: HTMLElement) {
    if (percentage >= 0 && percentage <= 0.5) {
      element.style.opacity = "1";
      element.style.transform = `translate(0%, ${
        -60 + 60 * percentage
      }%) translate3d(${20 * percentage * 2}px, 0px, ${
        -40 + 40 * percentage
      }px) rotateY(${
        180 - 180 * percentage
      }deg) scale(${percentage}, ${percentage})`;
    } else if (percentage > 0.5 && percentage <= 1) {
      element.style.opacity = "1";
      element.style.transform = `translate(0%, ${
        -60 + 60 * percentage
      }%) translate3d(${20 - 20 * (percentage - 0.5) * 2}px, 0px, ${
        -40 + 40 * percentage
      }px) rotateY(${
        180 - 180 * percentage
      }deg) scale(${percentage}, ${percentage})`;
    } else if (percentage > 1) {
      element.style.opacity = "1";
      element.style.transform = "translate(0%, 0%)";
    } else {
      element.style.opacity = "0";
    }
  }

  function textEffect2(percentage: number, element: HTMLElement) {
    if (percentage >= 0 && percentage <= 0.5) {
      element.style.opacity = "1";
      element.style.transform = `translate(0%, ${
        60 - 60 * percentage
      }%) translate3d(-${20 * percentage * 2}px, 0px, ${
        -40 + 40 * percentage
      }px) rotateY(-${
        180 - 180 * percentage
      }deg) scale(${percentage}, ${percentage})`;
    } else if (percentage > 0.5 && percentage <= 1) {
      element.style.opacity = "1";
      element.style.transform = `translate(0%, ${
        60 - 60 * percentage
      }%) translate3d(-${20 - 20 * (percentage - 0.5) * 2}px, 0px, ${
        -40 + 40 * percentage
      }px) rotateY(-${
        180 - 180 * percentage
      }deg) scale(${percentage}, ${percentage})`;
    } else if (percentage > 1) {
      element.style.opacity = "1";
      element.style.transform = "translate(0%, 0%)";
    } else {
      element.style.opacity = "0";
    }
  }

  function textEffect3(percentage: number, element: HTMLElement) {
    if (percentage >= 0 && percentage <= 1) {
      element.style.opacity = `${percentage}`;
    } else if (percentage > 1) {
      element.style.opacity = "1";
    } else {
      element.style.opacity = "0";
    }
  }

  function updateLettersState(): void {
    // Get bounding rectangle
    const rect = triggerElement.getBoundingClientRect();

    // distance between trigger element and browser top
    const browserViewHeight = document.documentElement.clientHeight;

    // start animation when trigger element appears
    if (rect.top < browserViewHeight) {
      aboutUsShortCode.style.opacity = "1";
      const scrolledDistance = browserViewHeight - rect.top;

      // percentage for different state
      const state1Percentage = scrolledDistance / browserViewHeight;
      const state2Percentage =
        (scrolledDistance - browserViewHeight * 0.3) / browserViewHeight;
      const state3Percentage =
        (scrolledDistance - browserViewHeight * 0.6) / browserViewHeight;
      const state4Percentage =
        (scrolledDistance - browserViewHeight * 0.8) / browserViewHeight;
      // row 1
      textEffect1(state1Percentage, letter1);
      textEffect2(state3Percentage, letter2);
      textEffect1(state2Percentage, letter3);
      textEffect2(state1Percentage, letter4);
      textEffect1(state3Percentage, letter5);
      textEffect2(state1Percentage, letter6);
      textEffect1(state2Percentage, letter7);
      textEffect2(state1Percentage, letter8);
      textEffect1(state2Percentage, letter9);
      textEffect2(state2Percentage, letter10);
      textEffect1(state3Percentage, letter11);
      // row 2
      textEffect1(state2Percentage, letter12);
      textEffect2(state1Percentage, letter13);
      textEffect1(state3Percentage, letter14);
      textEffect2(state1Percentage, letter15);
      textEffect1(state2Percentage, letter16);
      textEffect2(state1Percentage, letter17);
      textEffect1(state1Percentage, letter18);
      textEffect2(state1Percentage, letter19);
      textEffect1(state2Percentage, letter20);
      textEffect2(state3Percentage, letter21);
      // row 3
      textEffect1(state3Percentage, letter22);
      textEffect2(state1Percentage, letter23);
      textEffect1(state2Percentage, letter24);
      textEffect2(state1Percentage, letter25);
      textEffect1(state3Percentage, letter26);
      textEffect2(state2Percentage, letter27);
      textEffect1(state3Percentage, letter28);
      // chinese title
      textEffect3(state4Percentage, aboutUsTextTitle);
    } else {
      aboutUsShortCode.style.opacity = "0";
    }
  }

  // Update on scroll and resize
  window.addEventListener("scroll", updateLettersState);
  window.addEventListener("resize", updateLettersState);

  // Initial call to display distance on load
  updateLettersState();
}
